import { Routes, Route } from 'react-router-dom';
import { HealthcheckProjectPicker } from './HealthcheckProjectPicker';
import { HealthcheckConsole } from './HealthcheckConsole';
import { WorkspaceGate } from './onboarding';

/**
 * Healthcheck & Alerting (monitoring) module — project-scoped. Watchpoints are
 * filtered by `project_id`, so the picker selects a project (not a service).
 *
 *   /services/healthcheck                 → project picker
 *   /services/healthcheck/:projectId/*    → console (dashboard, monitors, incidents)
 *
 * Everything mounts behind `WorkspaceGate`: a single `GET /workspace` decides
 * whether to render the routes or the onboarding CTA — so no tenant-scoped child
 * query fires (and floods 403s) before a workspace exists.
 */
export function HealthcheckPage() {
  return (
    <WorkspaceGate>
      <Routes>
        <Route index element={<HealthcheckProjectPicker />} />
        <Route path=":projectId/*" element={<HealthcheckConsole />} />
      </Routes>
    </WorkspaceGate>
  );
}

export default HealthcheckPage;
